/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, IconButton, Chip, FormControl, Checkbox, FormHelperText } from '@material-ui/core';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Service';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types'
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTheme } from '@mui/material/styles';
import xlsx from 'json-as-xlsx';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

var screenCode = "GRNSUMMARYREPORT"

export default function GrnSummaryView(props) {
    const componentRef = useRef();
    const navigate = useNavigate();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'GRN Summary Report'
    });

    const [datevalue, setDateValue] = useState(new Date());
    const [toDatevalue, setToDateValue] = useState(new Date());
    const [productcatogery, setProductcatogery] = useState([]);
    const [product, setProduct] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [isHidden, setIsHidden] = useState(false);
    const [grnDetails, setGrnDetails] = useState([]);
    const [isEnable, setIsEnable] = useState(true);
    const [factoryTypeID, setFactoryTypeID] = useState(0);
    const [loginfactoryTypeID, setLoginFactoryID] = useState(0);
    const [grnData, setgrnData] = useState({
        grnName: ''
    });
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [formData, setFormData] = useState({
        groupID: '',
        operationEntityID: '',
        date: null,
        productID: ''
    });
    const [totalValues, setTotalValues] = useState({
        totalReceivedQty: 0,
        totalValue: 0,
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        productID: '',
        date: '',

    });
    const [selectedOptions, setSelectedOptions] = useState([]);
    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const classes = useStyles();

    const grnSummaryReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.array()
            .min("1", 'Please select at least one Fresh collection center')
            .required('Please select at least one Fresh collection center'),
        productCategoryID: Yup.array()
            .min(1, 'Please select at least one product category')
            .required('Please select at least one product category'),
        productID: Yup.array()
            .min(1, 'Please select at least one Product')
            .required('Please select at least one Product'),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            date: datevalue,
            toDate: toDatevalue,
            productID: selectedProductOptions,
            productCategoryID: selectedCategoryOptions,
        },

        validationSchema: grnSummaryReportSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
            setIsHidden(true)
        }
    });

    const isFutureDateDisabled = (date) => {
        return date > new Date();
    };

    async function SubmitForm(values) {
        let model = {
            groupID: parseInt(values.groupID),
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            productID: selectedProductOptions.map(x => x).join(',').toString(),
            date: new Date(datevalue).toISOString().split('T')[0],
            toDate: new Date(toDatevalue).toISOString().split('T')[0]
        }
        var res = await services.GetGrnSummaryReportDetails(model)
        setGrnDetails(res);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        if (!permissionList.isFactoryFilterEnabled) {
            setGrnDetails([]);
            setSelectedCategoryOptions([])
            setSelectedProductOptions([])
            setDateValue(new Date());
            setToDateValue(new Date());
        } else {
            setSelectedOptions([])
            setGrnDetails([]);
            setSelectedCategoryOptions([])
            setSelectedProductOptions([])
            setDateValue(new Date());
            setToDateValue(new Date());
        }
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(
            selectedOptions.map(x => x).join(','),
            selectedCategoryOptions.map(x => x).join(",")
        )
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productName, value: res[i].productID })
            }
            setProduct(newOptionArray);
        }
    }

    async function GetOperationEntityByGroupID() {
        let res = await services.GetVCCFactoriesByGroupID(formik.values.groupID);
        var newOptionArray = [];
        for (var i = 0; i < res.length; i++) {
            newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
        }
        setOperationEntityList(newOptionArray);
    }

    useEffect(() => {
        setPage(0);
        trackPromise(GetRouteByFactoryID());
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setPage(0);
    }, [formik.values.collectionCenterID]);

    useEffect(() => {
        setPage(0);
        getPermissions();
        trackPromise(GetProductDetails());
    }, [])

    useEffect(() => {
        GetAllGroups();
    }, []);

    useEffect(() => {
        setPage(0);
        if (selectedOptions.length == 0) {
            setProductcatogery([])
        } else {
            trackPromise(GetProductCategoties())
        }
    }, [selectedOptions])

    useEffect(() => {
        setPage(0);
        setGrnDetails([]);
    }, [formik.values.groupID, formik.values.operationEntityID, formik.values.productID, formik.values.date])

    useEffect(() => {
        setPage(0);
        setGrnDetails([]);
        setToDateValue(new Date());
    }, [datevalue]);

    useEffect(() => {
        setPage(0);
        setGrnDetails([]);
    }, [toDatevalue]);

    useEffect(() => {
        setPage(0);
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setPage(0);
        if (selectedOptions.length > 0 && selectedCategoryOptions.length > 0) {
            trackPromise(GetProductDetails())
        }
    }, [selectedCategoryOptions, selectedOptions])

    useEffect(() => {

        setDateValue(new Date());
        setToDateValue(new Date());
    }, [selectedCategoryOptions, selectedOptions,selectedProductOptions])

    useEffect(() => {
        setPage(0);
        setSelectedProductOptions([])
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        setPage(0);
        if (grnDetails.length != 0) {
            calculateTotal()
        }
    }, [grnDetails]);

    useEffect(() => {
        setPage(0);
        setSelectedCategoryOptions([])
        setSelectedProductOptions([])
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions,
            productID: selectedProductOptions,
            productCategoryID: selectedCategoryOptions,
        })
    }, [selectedOptions, selectedProductOptions, selectedCategoryOptions]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [operationEntityList]);

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    useEffect(() => {
        setPage(0)
        setGrnDetails([]);
    }, [selectedOptions, selectedCategoryOptions, selectedProductOptions, formik.values]);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - grnDetails.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSelectChange = (event) => {
        const selectedValues = event.target.value;
        if (selectedValues.includes('')) {
            setSelectedOptions(
                selectedOptions.length === operationEntityList.length
                    ? []
                    : operationEntityList.map((option) => option.value)
            );
        } else {
            setSelectedOptions(selectedValues);
        };
    };

    const handleSelectCategoryChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedCategoryOptions(
                selectedCategoryOptions.length === productcatogery.length ? [] :
                    productcatogery.map((option) => option.value)
            );
        } else {
            setSelectedCategoryOptions(value);
        }
    };

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties();
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productCategoryName, value: res[i].productCategoryID })
            }
            setProductcatogery(newOptionArray);
        }
    }

    const handleSelectProductChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedProductOptions(
                selectedProductOptions.length === product.length ? [] :
                    product.map((option) => option.value)
            );
        } else {
            setSelectedProductOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearCategorySelection = () => {
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearProductSelection = () => {
        setSelectedProductOptions([]);
    };

    function calculateTotal() {

        const totalReceivedQty = grnDetails.reduce((accumulator, current) => {
            const progressFraction = current.netAmount;
            return accumulator + progressFraction;
        }, 0);

        const totalValue = grnDetails.reduce((accumulator, current) => {
            const progressFraction = current.value;
            return accumulator + progressFraction;
        }, 0);

        setTotalValues({
            ...totalValues,
            totalReceivedQty: totalReceivedQty,
            totalValue: totalValue,
        });
    }

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWGRNSUMMARYREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
        var tokenFac = parseInt(TokenDecoder.getFactoryTypeFromToken())
        setFactoryTypeID(tokenFac);
        setLoginFactoryID(parseInt(TokenDecoder.getFactoryTypeFromToken()))
    }

    async function GetRouteByFactoryID() {
        var res = await services.GetRouteByFactoryID(formik.values.operationEntityID)
        if (res != null) {
            setRoute(res);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(grnDetails);
        var settings = {
            sheetName: 'GRN Summary Details',
            fileName: 'GRN Summary Details',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'GRN Summary Details',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }


    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.forEach(x => {
                var vr = {
                    'Date' : moment(new Date(x.grnDate)).format('YYYY-MM-DD'),
                    'Fresh Collection Center': x.factoryName,
                    'SKU Description': x.productName,
                    'SKU Code': x.productCode,
                    'Net Amount(Received Qty)': x.netAmount.toFixed(2),
                    'Value (Rs)': x.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                };
                res.push(vr);
            });
            // var vrTotal = {
            //     'Fresh Collection Center': "Total",
            //     'Net Amount(Received Qty)': totalValues.totalReceivedQty,
            //     'Value (Rs)': totalValues.totalValue
            // }
            // res.push(vrTotal);
            res.push({});
        }
        return res;
    }

    function getSelectedDropdownValuesForReport() {

        const facName = [];
        var newSelectedRow = selectedOptions.filter(x => x !== 1)
        newSelectedRow.forEach(x => {
            const fildered = operationEntityList.find(y => x === y.value).label
            facName.push(fildered)
        });

        const productName = [];
        selectedProductOptions.forEach(x => {
            const filterProduct = product.find(y => x === y.value).label
            productName.push(filterProduct)
        });

        let groups = groupList.find(x => x.groupID == formik.values.groupID)

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: facName.map(x => x).join(','),
            productID: productName.map(x => x).join(','),
            date: new Date(datevalue).toISOString().split('T')[0],
            toDate: new Date(toDatevalue).toISOString.split('T')[0],
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = operationEntityList.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderProductSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = product.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderCategorySelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = productcatogery.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="GRN Summary Report  |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Group *"
                                            value={formik.values.groupID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('groupID')}
                                            error={Boolean(touched.groupID && errors.groupID)}
                                            helperText={touched.groupID && errors.groupID}
                                            InputProps={{
                                                readOnly: !permissionList.isGroupFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}>Select Group</MenuItem>
                                            {groupList.map((option) => (
                                                option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                    {option.groupName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField>

                                        <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                            <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                            <Select
                                                className="custom-select"
                                                labelId="multi-select-label"
                                                id="multi-select"
                                                multiple
                                                size="small"
                                                value={selectedOptions}
                                                onChange={handleSelectChange}
                                                label="Fresh Collection Center "
                                                disabled={!permissionList.isFactoryFilterEnabled}
                                                renderValue={(selected) => renderSelectedValue(selected)}
                                            >
                                                <MenuItem key={0} value={""}>
                                                    <Checkbox checked={selectedOptions.length === operationEntityList.length} color="primary" />
                                                    All Fresh Collection Center
                                                </MenuItem>
                                                {operationEntityList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {touched.operationEntityID && errors.operationEntityID && (
                                                <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                            )}
                                            {selectedOptions.length > 0 && (
                                                <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                    {!permissionList.isFactoryFilterEnabled ? null :
                                                        <ClearIcon />}
                                                </IconButton>
                                            )}
                                        </FormControl>


                                        <FormControl fullWidth error={Boolean(touched.productCategoryID && errors.productCategoryID)}>
                                            <InputLabel id="multi-select-label">Product Category * </InputLabel>
                                            <Select
                                                className="custom-select"
                                                labelId="multi-select-label"
                                                id="multi-select"
                                                multiple
                                                size="small"
                                                value={selectedCategoryOptions}
                                                onChange={handleSelectCategoryChange}
                                                label="Product Category "
                                                renderValue={(selected) => renderCategorySelectedValue(selected)}
                                            >
                                                <MenuItem key={0} value={""}>
                                                    <Checkbox checked={selectedCategoryOptions.length === productcatogery.length} color="primary" />
                                                    All Product Category
                                                </MenuItem>
                                                {productcatogery.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        <Checkbox checked={selectedCategoryOptions.indexOf(option.value) > -1} color="primary" />
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {touched.productCategoryID && errors.productCategoryID && (
                                                <FormHelperText>{errors.productCategoryID}</FormHelperText>
                                            )}
                                            {selectedCategoryOptions.length > 0 && (
                                                <IconButton onClick={handleClearCategorySelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                    <ClearIcon />
                                                </IconButton>
                                            )}
                                        </FormControl>
                                    </Stack>
                                    <br />
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <FormControl fullWidth error={Boolean(touched.productID && errors.productID)}>
                                            <InputLabel id="multi-select-label">Product * </InputLabel>
                                            <Select
                                                className="custom-select"
                                                labelId="multi-select-label"
                                                id="multi-select"
                                                multiple
                                                size="small"
                                                value={selectedProductOptions}
                                                onChange={handleSelectProductChange}
                                                label="Product "
                                                renderValue={(selected) => renderProductSelectedValue(selected)}
                                            >
                                                <MenuItem key={0} value={""}>
                                                    <Checkbox checked={selectedProductOptions.length === product.length} color="primary" />
                                                    All Products
                                                </MenuItem>
                                                {product.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        <Checkbox checked={selectedProductOptions.indexOf(option.value) > -1} color="primary" />
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {touched.productID && errors.productID && (
                                                <FormHelperText>{errors.productID}</FormHelperText>
                                            )}
                                            {selectedProductOptions.length > 0 && (
                                                <IconButton onClick={handleClearProductSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                    <ClearIcon />
                                                </IconButton>
                                            )}
                                        </FormControl>

                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                fullWidth
                                                // size="small"
                                                label="From Date *"
                                                openTo="day"
                                                type="date"
                                                inputFormat="MM/DD/YYYY"
                                                value={datevalue}
                                                onChange={(newValue) => {
                                                    setDateValue(newValue);
                                                }}
                                                shouldDisableDate={isFutureDateDisabled}
                                                renderInput={(params) =>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...params}
                                                    />}
                                            />
                                        </LocalizationProvider>

                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                fullWidth
                                                // size="small"
                                                label="To Date *"
                                                openTo="day"
                                                type="toDate"
                                                inputFormat="MM/DD/YYYY"
                                                value={toDatevalue}
                                                onChange={(newValue) => {
                                                    setToDateValue(newValue);
                                                }}
                                                shouldDisableDate={isFutureDateDisabled}
                                                renderInput={(params) =>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...params}
                                                    />}
                                            />
                                        </LocalizationProvider>
                                    </Stack>
                                    <div>
                                        <br />
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button type="button" variant="outlined" color="error"
                                                onClick={() => clearAll()}
                                            >
                                                Clear
                                            </Button>
                                            <Button type="submit" color="secondary" variant="outlined"
                                            >
                                                Search
                                            </Button>
                                        </Stack>
                                    </div>
                                </Stack>
                                <br />
                                {isEnable == false ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginBottom: '10px' }} justifyContent="right" spacing={2}>
                                        <TextField
                                            size="small"
                                            style={{ width: '300px' }}
                                            value={grnData.grnName}
                                            placeholder="Search"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Stack> : null}
                                {grnDetails.length != 0 ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>

                                        <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                            <TableContainer component={Paper} >
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                        <TableCell align="center">Date</TableCell>
                                                            <TableCell align="center">Fresh Collection Center</TableCell>
                                                            <TableCell align="center">SKU Description</TableCell>
                                                            <TableCell align="center">SKU Code</TableCell>
                                                            <TableCell align="right">Net Amount(Received Qty)</TableCell>
                                                            <TableCell align="right">Value (Rs.)</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(rowsPerPage > 0
                                                            ? grnDetails
                                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            : grnDetails
                                                        ).map((row) => (
                                                            <TableRow key={row.productCode}>
                                                                 <TableCell align="center">
                                                                    {moment(new Date(row.grnDate)).format('YYYY-MM-DD')}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.factoryName}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.productName}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.productCode}
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    {parseFloat(row.netAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    {parseFloat(row.value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        <TableRow>
                                                            <TableCell sx={{ fontWeight: "bold" }} align="center" colSpan={4}>
                                                                Total
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(totalValues.totalReceivedQty).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                                            <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(totalValues.totalValue).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                                        </TableRow>
                                                        {emptyRows > 0 && (
                                                            <TableRow style={{ height: 53 * emptyRows }}>
                                                                <TableCell colSpan={6} />
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                    <TableFooter>
                                                        <TableRow>
                                                            <TablePagination
                                                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                                colSpan={6}
                                                                count={grnDetails.length}
                                                                rowsPerPage={rowsPerPage}
                                                                page={page}
                                                                SelectProps={{
                                                                    inputProps: {
                                                                        'aria-label': 'rows per page',
                                                                    },
                                                                    native: true,
                                                                }}
                                                                onPageChange={handleChangePage}
                                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                                ActionsComponent={TablePaginationActions}
                                                            />
                                                        </TableRow>
                                                    </TableFooter>
                                                </Table>
                                            </TableContainer>
                                        </Card>
                                    </Stack> : <SearchNotFound searchQuery="GRN Summary Details" />}
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {grnDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"GRN Summary Details"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    grnDetails={grnDetails}
                                    totalValues={totalValues}
                                    searchData={selectedSearchValues}
                                />
                            </div>
                        </Box>
                        : null}
                </Container>
            </Page>
        </>
    );
}
